import { createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Initialise client-side error reporting (Sentry). Browser-only: the dynamic
// import keeps @sentry/react out of the SSR (workerd) bundle entirely, and
// lib/sentry self-guards on `window` before calling Sentry.init. Without this
// side-effect import, lib/sentry is tree-shaken out and the FE reports nothing.
if (typeof window !== 'undefined') {
  void import('./lib/sentry')
}

// status.uptrack.app/ shows Uptrack's own status page at the root URL. The router
// reads it as /status/uptrack (server and client) and writes it back as /.
const STATUS_HOST = 'status.uptrack.app'
const STATUS_PATH = '/status/uptrack'

export const statusHostRewrite = {
  input: ({ url }: { url: URL }) => {
    if (url.hostname === STATUS_HOST && url.pathname === '/') {
      url.pathname = STATUS_PATH
      return url
    }
    return undefined
  },
  output: ({ url }: { url: URL }) => {
    if (url.hostname === STATUS_HOST && url.pathname === STATUS_PATH) {
      url.pathname = '/'
      return url
    }
    return undefined
  },
}

// Create a new router instance
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {},

    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    rewrite: statusHostRewrite,
  })

  return router
}
